var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"traction__map-captain"},[_c('MsgInfo',{attrs:{"data":_vm.data.user,"info":_vm.data.info}}),_c('MsgWeeks',{attrs:{"data":_vm.data.weeks,"isUpdate":_vm.isUpdate,"info":_vm.data.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }